import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const OptionsLevelEligibilityModal = (props) => {
  const {
    onClose,
  } = props;

  return (
    <Modal
      show
      onHide={onClose}
      backdrop
      centered
      className="options-submit-modal"
    >
      <div className="options-submit-modal-div">
        <Modal.Header closeButton id="options-modal-title">
          <h1 id="page-header" className="h1_secondary">
            Options Level Eligibility
          </h1>
        </Modal.Header>
        <Modal.Body className="options-submit-modal-body">
          <p className="panel-question">
            TradeStation evaluates a client&apos;s options level eligibility based upon several factors
            including the client&apos;s trading experience, financial situation, and investment objectives.
            These client suitability factors, in combination with firm rules that apply limits to cash
            and IRA accounts, help TradeStation determine which options levels may be appropriate for the client.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-center">
            <button
              type="button"
              className="btn btn-raised btn-default do_capitalize"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

OptionsLevelEligibilityModal.propTypes = {
  onClose: PropTypes.func,
};

export default OptionsLevelEligibilityModal;
